module.exports = __webpack_public_path__ + "static/dinosaur-27ffca2440bfda2226ae07c4ac6811ac.png";